import React, { Component } from 'react';

import { StringUtils, DateUtils } from '../utils';
import { Routes as routes } from '../navigation';
import { Button } from '../components';
import '../css/SignIn.css';

class ConsultationsActive extends Component {

  constructor(props) {
    super(props);
    this.state = {
      displayCount: 5,
    }
  }

  renderActiveConsultations = (activeConsultationIDs) => {

    if (!activeConsultationIDs || this.props.hideIfEmpty === true && activeConsultationIDs.length === 0) {
      return null
    }

    const activeConsultations = activeConsultationIDs.map((consultationID) => {
      const consultation = this.props.consultations && this.props.consultations[consultationID] ? this.props.consultations[consultationID] : {};
      if (consultation) {
        const consultationHasLocation = consultation.location_id ? true : false;
        const locationFilterSet   = this.props.filterLocation === true && this.props.locationId ? true : false;
        const displayWithFilter   = consultationHasLocation && locationFilterSet && consultation.location_id === this.props.locationId ? true : false;
        const displayConsultation = (locationFilterSet && displayWithFilter) || (!locationFilterSet)
        if (consultation.practice_id === this.props.practiceID && displayConsultation) {
          return consultation;
        }
      }
    }).filter((consult) => { return consult }).sort((a, b) => { return new Date(b.updated_at) - new Date(a.updated_at) });

    const consultationRows = activeConsultations.map((consultation, index) => {
      if (!consultation || !consultation._id || index >= this.state.displayCount) {
        return null;
      }
      const subject         = consultation.subject || '';
      const primaryClient   = this.props.users && this.props.users[consultation.primary_client] ? this.props.users[consultation.primary_client] : null;
      const patient         = this.props.patients && this.props.patients[consultation.patient_id] ? this.props.patients[consultation.patient_id] : null;
      const startDateString = DateUtils.getShortMonth(consultation.created_at) + ' ' + DateUtils.getDateNumber(consultation.created_at) + ', ' + DateUtils.getTime(consultation.created_at);
      const subTitle        = primaryClient && patient && patient.name ? StringUtils.displayName(primaryClient).toUpperCase() + ' | ' + StringUtils.displayName(patient).toUpperCase() + ' | ' + startDateString : '';
      const displayBadge    = this.props.notifications && this.props.notifications[consultation._id] ? true : false;

      return <div key={consultation._id} className="flex-container flex-container-row flex-space-between flex-center-align" style={{ marginBottom: 10 }}>
        <div className="flex-container flex-container-column">
          <span>{ subject }</span>
          <span style={{ fontSize: 12, color: '#1dc2ff', marginTop: -3 }}>{ subTitle }</span>
        </div>
        <div className='flex-container-row' style={{ alignItems: 'center' }}>
          { displayBadge ? <div style={{ height: 10, width: 10, backgroundColor: 'red', marginRight: 10, borderRadius: 5 }}></div> : null }
          <input  type="submit"
                  value="Open"
                  className="button-clear-blue"
                  style={{ color: '#1dc2ff'}}
                  onClick={() => { this.props.consultationsActions.openConsultation(this.props.token, consultation) }}
                />
        </div>
      </div>
    }).filter((row) => { return row });

    let displaySeeMoreButton = activeConsultations.length > this.state.displayCount;

    return <div className="basic-container">
      <h4 style={{ marginBottom: 20 }}>Active Consultations</h4>
      { consultationRows }
      { displaySeeMoreButton ? <div className='flex-container-row' style={{ justifyContent: 'flex-end' }}>
                                <Button
                                    value='See More'
                                    style={{ marginTop: 5 }}
                                    onClick={ () => {
                                      this.setState({ ...this.state, displayCount: this.state.displayCount + 10 }) }}
                                  />
                                </div>
                             : null }
      { activeConsultationIDs.length === 0 || consultationRows.length === 0
      ? <div className="flex-container flex-container-row flex-center-align flex-center-justify" style={{ margin: 15, fontSize: 14, color: 'grey' }}>
          There are no Active Consultations associated with your account
        </div>
      : null  }

    </div>
  }

  render() {
    return this.renderActiveConsultations(this.props.activeConsultations);
  }

}


export default ConsultationsActive
